/* eslint-disable import/prefer-default-export */
import { css } from "styled-components";

/**
 * Padrão mobile-first para o elemento raiz de cada rota:
 * ocupa a largura, altura mínima da viewport, coluna flexível, safe-area, sem overflow horizontal.
 */
export const pageRoot = css`
  width: 100%;
  min-height: 100%;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
`;
